"use strict";Object.defineProperty(exports,"__esModule",{value:!0});exports.LOCAL_STORAGE_CHANGE_EVENT="gv:onLocalStorageChange";
//# sourceMappingURL=events.js.map
